/* edekor ekstralar: kenar sepet, AJAX sepete ekleme, hızlı bakış, zoom, duyuru, stok, son bakılanlar */
(function () {
  'use strict';
  var root = document.getElementById('LexX');
  if (!root) return;
  document.documentElement.appendChild(root); /* body zoom'undan bağımsız olsun */

  var THR = parseInt(root.getAttribute('data-threshold'), 10) || 50000;
  var CUR = root.getAttribute('data-currency') || 'TRY';
  var CART_URL = root.getAttribute('data-cart-url') || '/cart';
  var $ = function (id) { return document.getElementById(id); };
  var drawerBody = $('LexDrawerBody'), drawerFoot = $('LexDrawerFoot'), ship = $('LexShip');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: CUR }).format((Number(c) || 0) / 100); }
    catch (e) { return ((Number(c) || 0) / 100).toFixed(2) + ' TL'; }
  }
  function toast(msg, err) {
    var t = $('LexToast'); t.textContent = msg; t.className = 'lex-toast show' + (err ? ' err' : '');
    clearTimeout(toast.t); toast.t = setTimeout(function () { t.className = 'lex-toast'; }, 3200);
  }

  /* ---------- Katman yönetimi ---------- */
  var mode = '';
  function openLayer(name) {
    closeAll(true);
    mode = name;
    root.classList.add('is-open', 'is-' + name);
    var el = name === 'drawer' ? $('LexDrawer') : name === 'qv' ? $('LexQV') : null;
    if (el) el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeAll(keep) {
    root.classList.remove('is-open', 'is-drawer', 'is-qv');
    ['LexDrawer', 'LexQV'].forEach(function (i) { $(i).setAttribute('aria-hidden', 'true'); });
    $('LexLB').classList.remove('is-open'); $('LexLB').setAttribute('aria-hidden', 'true');
    if (!keep) document.documentElement.style.overflow = '';
    mode = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-x-close]')) closeAll();
    else if (e.target === $('LexQV')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
    if ($('LexLB').classList.contains('is-open')) { if (e.key === 'ArrowLeft') lbStep(-1); if (e.key === 'ArrowRight') lbStep(1); }
  });

  /* ---------- Sepet ---------- */
  var cart = null;
  function jget(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function setCount(n) {
    document.querySelectorAll('.cart-icon b').forEach(function (b) { b.textContent = n; });
    try { sessionStorage.setItem('lexCartCount', String(n)); } catch (e) {}
  }
  function bump() {
    var c = document.querySelector('.cart-icon'); if (!c || reduce) return;
    c.classList.remove('lex-cart-bump'); void c.offsetWidth; c.classList.add('lex-cart-bump');
    setTimeout(function () { c.classList.remove('lex-cart-bump'); }, 1000);
  }
  function render(c) {
    cart = c; setCount(c.item_count);
    var left = THR - c.total_price, pct = Math.max(0, Math.min(100, Math.round(c.total_price * 100 / THR)));
    ship.innerHTML = c.item_count === 0 ? '' :
      '<p>' + (left > 0 ? 'Ücretsiz kargo için <strong>' + money(left) + '</strong> daha ekleyin' : '🎉 <strong>Ücretsiz kargo</strong> kazandınız!') + '</p><div class="lex-ship-bar"><span style="width:' + pct + '%"></span></div>';
    ship.style.display = c.item_count === 0 ? 'none' : '';
    if (!c.items.length) {
      drawerBody.innerHTML = '<div class="lex-drawer-empty"><b>🛒</b>Sepetiniz şu an boş.<br><br><a class="lex-b" href="/collections/all">Alışverişe Başla →</a></div>';
      drawerFoot.innerHTML = ''; return;
    }
    drawerBody.innerHTML = c.items.map(function (it) {
      var v = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="lex-di-v">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="lex-di" data-key="' + esc(it.key) + '">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '<img alt="">') +
        '<div><a class="lex-di-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + v +
        '<div class="lex-di-q"><button type="button" data-q="-1" aria-label="Azalt">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Arttır">+</button></div>' +
        '<button type="button" class="lex-di-rm" data-rm>Kaldır</button></div>' +
        '<div class="lex-di-p">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    drawerFoot.innerHTML = '<div class="lex-sub"><span>Ara toplam</span><span>' + money(c.total_price) + '</span></div>' +
      '<div class="lex-sub-n">Kargo ve vergiler ödeme adımında hesaplanır.</div>' +
      '<a class="lex-b" href="' + CART_URL + '/checkout" onclick="return false" data-checkout>Ödemeye Geç →</a>' +
      '<a class="lex-b alt" href="' + CART_URL + '">Sepeti Görüntüle</a>';
  }
  function refresh() { return jget('/cart.js').then(render); }
  function openDrawer() { openLayer('drawer'); if (cart) render(cart); refresh(); }
  function change(key, q) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(function (c) { if (c.items) render(c); else toast(c.description || 'Güncellenemedi', true); });
  }
  drawerBody.addEventListener('click', function (e) {
    var row = e.target.closest('.lex-di'); if (!row) return;
    var key = row.getAttribute('data-key'), it = cart && cart.items.filter(function (x) { return x.key === key; })[0]; if (!it) return;
    var q = e.target.closest('[data-q]');
    if (q) change(key, Math.max(0, it.quantity + parseInt(q.getAttribute('data-q'), 10)));
    else if (e.target.closest('[data-rm]')) change(key, 0);
  });
  drawerFoot.addEventListener('click', function (e) {
    var a = e.target.closest('[data-checkout]'); if (!a) return;
    e.preventDefault();
    var f = document.createElement('form'); f.method = 'post'; f.action = CART_URL;
    f.innerHTML = '<input type="hidden" name="checkout" value="">'; document.body.appendChild(f); f.submit();
  });

  function addToCart(payload, btn) {
    var old = btn && btn.innerHTML;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ekleniyor…'; }
    var opts = payload instanceof FormData ? { method: 'POST', body: payload, headers: { Accept: 'application/json' } }
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) };
    return fetch('/cart/add.js', opts).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.innerHTML = old; }
        if (!res.ok) { toast(res.d.description || res.d.message || 'Ürün sepete eklenemedi', true); return false; }
        return refresh().then(function () { openDrawer(); bump(); return true; });
      }).catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = old; } toast('Bağlantı hatası, tekrar deneyin', true); });
  }
  window.LexCart = { open: openDrawer, add: addToCart, refresh: refresh };

  /* Sepet ikonu → kenar sepet */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.cart-icon');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || /^\/cart(\/|$)/.test(location.pathname)) return;
    e.preventDefault(); openDrawer();
  });
  /* Ürün formları → AJAX */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add/.test(f.action) || e.defaultPrevented) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    addToCart(new FormData(f), btn);
  }, true);

  /* ---------- Duyuru bandı ---------- */
  (function () {
    var wrap = document.querySelector('[data-lex-ann]'); if (!wrap) return;
    var items = [].filter.call(wrap.querySelectorAll('.lex-ann-item'), function (el) { return el.textContent.trim(); });
    [].forEach.call(wrap.querySelectorAll('.lex-ann-item'), function (el) { if (!el.textContent.trim()) el.style.display = 'none'; });
    if (items.length) { items.forEach(function (el) { el.classList.remove('is-active'); }); items[0].classList.add('is-active'); }
    if (items.length < 2) return;
    var i = 0, paused = false;
    wrap.addEventListener('mouseenter', function () { paused = true; });
    wrap.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var cur = items[i]; cur.classList.remove('is-active'); cur.classList.add('is-out');
      i = (i + 1) % items.length;
      var nx = items[i]; nx.classList.remove('is-out'); void nx.offsetWidth; nx.classList.add('is-active');
      setTimeout(function () { cur.classList.remove('is-out'); }, 800);
    }, 4200);
  })();

  /* ---------- Hızlı bakış ---------- */
  function placeQv(card) {
    var m = card.querySelector('.product-media'), b = card.querySelector('.lex-qv-btn');
    if (m && b) b.style.top = (m.offsetTop + m.offsetHeight - 54) + 'px';
  }
  function addQv(card) {
    if (card.querySelector('.lex-qv-btn')) return;
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/); if (!m) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'lex-qv-btn'; b.textContent = 'Hızlı Bak'; b.setAttribute('data-handle', m[1]);
    card.appendChild(b); placeQv(card);
    card.addEventListener('mouseenter', function () { placeQv(card); });
  }
  function scanCards() { document.querySelectorAll('.product-card').forEach(addQv); }
  scanCards();
  window.addEventListener('load', scanCards);
  if (window.MutationObserver) new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { scanCards(); break; } }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lex-qv-btn'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); quickView(b.getAttribute('data-handle'));
  }, true);

  function quickView(handle) {
    var body = $('LexQVBody'); body.innerHTML = '<div style="padding:60px;text-align:center;color:#7a867f">Yükleniyor…</div>';
    openLayer('qv');
    jget('/products/' + handle + '.js').then(function (p) {
      var sel = {}, vid = null, qty = 1;
      var imgs = (p.images || []).map(function (s) { return s; });
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      (p.options || []).forEach(function (o, i) { sel[i] = first.options[i]; });
      var single = p.variants.length === 1;
      var desc = (p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim(); if (desc.length > 220) desc = desc.slice(0, 217) + '…';
      body.innerHTML = '<div class="lex-qv-grid"><div><div class="lex-qv-img"><img id="qvImg" alt=""></div><div class="lex-qv-thumbs" id="qvThumbs"></div></div>' +
        '<div class="lex-qv-info"><span class="eyebrow" style="color:#00a62b;font-weight:800;font-size:12px;letter-spacing:1px">' + esc((p.vendor || 'EDEKOR.COM').toUpperCase()) + '</span><h3>' + esc(p.title) + '</h3>' +
        '<div class="lex-qv-price" id="qvPrice"></div>' + (desc ? '<div class="lex-qv-desc">' + esc(desc) + '</div>' : '') +
        '<div id="qvOpts"></div><div class="lex-qv-row"><div class="lex-qv-qty"><button type="button" id="qvMinus">−</button><input id="qvQty" type="number" min="1" value="1"><button type="button" id="qvPlus">+</button></div>' +
        '<button type="button" class="lex-b" id="qvAdd">Sepete Ekle →</button></div><a class="lex-qv-link" href="' + esc(p.url) + '">Ürünün tüm detayları →</a></div></div>';
      var qi = $('qvQty');
      function cur() { return p.variants.filter(function (v) { return (p.options || []).every(function (o, i) { return v.options[i] === sel[i]; }); })[0]; }
      function setImg(src) {
        if (!src) return; $('qvImg').src = src;
        [].forEach.call($('qvThumbs').children, function (t) { t.classList.toggle('on', t.getAttribute('data-src') === src); });
      }
      function paint() {
        var v = cur(); vid = v ? v.id : null;
        $('qvPrice').innerHTML = v ? money(v.price) + (v.compare_at_price > v.price ? '<del>' + money(v.compare_at_price) + '</del>' : '') : 'Bu seçenek mevcut değil';
        var add = $('qvAdd'); add.disabled = !v || !v.available; add.innerHTML = !v ? 'Mevcut değil' : v.available ? 'Sepete Ekle →' : 'Tükendi';
        if (v && v.featured_image) setImg(v.featured_image.src);
      }
      if (!single) {
        $('qvOpts').innerHTML = p.options.map(function (o, i) {
          var vals = []; p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
          return '<div class="lex-qv-opt"><label>' + esc(o.name || o) + '</label><select data-i="' + i + '">' + vals.map(function (x) { return '<option' + (x === sel[i] ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select></div>';
        }).join('');
        $('qvOpts').addEventListener('change', function (e) { var i = e.target.getAttribute('data-i'); if (i !== null) { sel[i] = e.target.value; paint(); } });
      }
      $('qvThumbs').innerHTML = imgs.length > 1 ? imgs.slice(0, 8).map(function (s) { return '<button type="button" data-src="' + esc(s) + '"><img src="' + esc(s) + '" alt=""></button>'; }).join('') : '';
      $('qvThumbs').addEventListener('click', function (e) { var t = e.target.closest('button'); if (t) setImg(t.getAttribute('data-src')); });
      setImg(imgs[0] || (p.featured_image || '')); paint();
      $('qvMinus').onclick = function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); };
      $('qvPlus').onclick = function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; };
      $('qvAdd').onclick = function () { if (!vid) return; addToCart({ id: vid, quantity: Math.max(1, parseInt(qi.value, 10) || 1) }, $('qvAdd')); };
    }).catch(function () { closeAll(); toast('Ürün yüklenemedi', true); });
  }

  /* ---------- Ürün sayfası: zoom + lightbox ---------- */
  var box = document.querySelector('.lex-product-main-image');
  var lbList = [], lbIdx = 0;
  function bigger(u) { return String(u || '').replace(/width=\d+/, 'width=2000'); }
  function lbShow() { $('LexLBImg').src = bigger(lbList[lbIdx]); }
  function lbStep(d) { if (lbList.length < 2) return; lbIdx = (lbIdx + d + lbList.length) % lbList.length; lbShow(); }
  $('LexLB').querySelector('.lex-lb-prev').addEventListener('click', function () { lbStep(-1); });
  $('LexLB').querySelector('.lex-lb-next').addEventListener('click', function () { lbStep(1); });
  $('LexLB').addEventListener('click', function (e) { if (e.target === $('LexLB')) closeAll(); });
  if (box) {
    var img = box.querySelector('img');
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (fine && !reduce && img) {
      box.addEventListener('mouseenter', function () { box.classList.add('lex-zooming'); });
      box.addEventListener('mouseleave', function () { box.classList.remove('lex-zooming'); img.style.transformOrigin = '50% 50%'; });
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    }
    box.addEventListener('click', function () {
      var cur = $('lexProductMainImage'); if (!cur) return;
      lbList = [].map.call(document.querySelectorAll('[data-product-image]'), function (t) { return t.getAttribute('data-product-image'); });
      var src = cur.currentSrc || cur.src; lbIdx = Math.max(0, lbList.indexOf(src));
      if (!lbList.length) lbList = [src];
      if (lbList.indexOf(src) < 0) { lbList.unshift(src); lbIdx = 0; }
      $('LexLB').classList.toggle('single', lbList.length < 2);
      lbShow(); closeAll(true); $('LexLB').classList.add('is-open'); $('LexLB').setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    });
  }

  /* ---------- Düşük stok ---------- */
  (function () {
    var stockEl = $('lexStock'), data = $('LexStock'); if (!stockEl || !data) return;
    var map = {}; try { map = JSON.parse(data.textContent); } catch (e) { return; }
    function vid() { var i = document.querySelector('#LexProductForm [name="id"]'); return i ? i.value : ''; }
    function upd() {
      var q = map[vid()];
      if (typeof q === 'number' && q > 0 && q <= 5) { stockEl.textContent = 'Son ' + q + ' ürün kaldı!'; stockEl.hidden = false; }
      else stockEl.hidden = true;
    }
    upd();
    var last = vid(); setInterval(function () { var v = vid(); if (v !== last) { last = v; upd(); } }, 350);
  })();

  /* ---------- Son baktıklarınız ---------- */
  (function () {
    var page = document.querySelector('.lex-product-page[data-product-handle]');
    var KEY = 'lexRecent', list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (!page) return;
    var cur = page.getAttribute('data-product-handle');
    var others = list.filter(function (h) { return h !== cur; });
    try { localStorage.setItem(KEY, JSON.stringify([cur].concat(others).slice(0, 12))); } catch (e) {}
    var wrap = $('LexRecent'), grid = $('LexRecentGrid'); if (!wrap || !grid || !others.length) return;
    Promise.all(others.slice(0, 4).map(function (h) { return jget('/products/' + h + '.js').catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(function (p) { return p && p.title; }); if (!ps.length) return;
      grid.innerHTML = ps.map(function (p) {
        return '<article class="product-card"><a href="' + esc(p.url) + '" class="product-media">' + (p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="product-info"><a href="' + esc(p.url) + '" class="product-title">' + esc(p.title) + '</a><div class="price-row"><span class="price">' + money(p.price) + '</span></div></div></article>';
      }).join('');
      wrap.hidden = false; scanCards();
    });
  })();
})();
